import { useContext } from "react";
import { ConfigContext } from "../contexts/ConfigContext";
var useConfig = function () { return useContext(ConfigContext); };
// eslint-disable-next-line import/no-default-export
export default useConfig;
